import giftBox from "../../../images/gift.png";

export default function Fellowshipgift() {
    return (
        <div className="w-full flex flex-col items-center px-6 pt-10 bg-white mb-5">
        {/* Heading */}
        <h2
          className="text-3xl md:text-5xl tracking-wide font-bold text-blue-500 mb-10"
          style={{ fontFamily: "Montserrat" }}
        >
          Fellowship Grant
        </h2>
  
        {/* Image + Text Row */}
        <div className="flex flex-col md:flex-row items-center justify-between w-[70%] gap-15 ">
          {/* Left - Image */}
          <img
            src={giftBox}
            alt="Gift"
            className="w-[250px] md:w-[480px]"
          />
  
          {/* Right - Text Boxes */}
          <div className="flex flex-col gap-6">
            <div style={{ fontFamily: "Poppins" }} className="bg-[#D3C4F3] text-black px-6 py-5 rounded-xl text-center text-lg font-medium w-[300px] md:w-[400px] shadow transition-tranform hover:scale-105">
              Top 10 ideas will be awarded the <br /> Fellowship Grant!
            </div>
            <div style={{ fontFamily: "Poppins" }} className="bg-[#FFD479] text-black px-6 py-5 rounded-xl text-center text-lg font-medium w-[300px] md:w-[400px] shadow transition-tranform hover:scale-105">
              A total of INR 2 Cr will be distributed <br /> among the winners!
            </div>
          </div>
        </div>
      </div>
    )
}